var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47,12a2,2,0,0,0-2-2H24a2,2,0,0,0,0,4H45A2,2,0,0,0,47,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,14H8.35a6,6,0,1,0,0-4H3a2,2,0,0,0,0,4Zm11-4a2,2,0,1,1-2,2A2,2,0,0,1,14,10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45,22H37.65a6,6,0,1,0,0,4H45a2,2,0,0,0,0-4ZM32,26a2,2,0,1,1,2-2A2,2,0,0,1,32,26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22H3a2,2,0,0,0,0,4H22a2,2,0,0,0,0-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45,34H28a2,2,0,0,0,0,4H45a2,2,0,0,0,0-4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a6,6,0,0,0-5.65,4H3a2,2,0,0,0,0,4h9.35A6,6,0,1,0,18,30Zm0,8a2,2,0,1,1,2-2A2,2,0,0,1,18,38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/filter_svg.1d126723bda3d74e406b4e8cbb5760ee.svg";
export { ForwardRef as ReactComponent };